import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'

const H4 = ({ children, marginBottom, marginTop, withBorder, ...rest }) => (
  <ThemeProvider theme={theme}>
    <Heading
      className={cn({
        marginBottom,
        marginTop,
        withBorder,
      })}
      {...rest}
    >
      {children}
    </Heading>
  </ThemeProvider>
)

const Heading = styled.h4`
  font-size: ${props => props.theme.typography.fontSizeSm};
  font-weight: ${props => props.theme.typography.fontWeightBold};
  color: var(--gameday-body-headingColor, ${theme.body.headingColor});
  margin: 0;
  &.marginBottom {
    margin-bottom: 16px;
  }
  &.marginTop {
    margin-top: 16px;
  }
  &.withBorder {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${props => props.theme.body.headingBorderColor};
  }
`

H4.defaultProps = {
  marginBottom: true,
  marginTop: true,
  withBorder: false,
}

export default H4
